import React from 'react';
import ErrorPage from '../pages/ErrorPage';

export default class AppErrorBoundary extends React.Component<
  { children: React.ReactNode },
  { hasError: boolean }
> {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    return this.state.hasError ? <ErrorPage recovery /> : this.props.children;
  }
}
